import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

import { AccordionClosedIcon, AccordionOpenIcon } from '../../common/icons';

const styles = require('./section-accordion.css');

/** Props for the component */
export interface SectionAccordionProps {
  /** Additional classes to apply */
  className?: string;
  /** Header title */
  headerTitle: string;
  /** Content to show when accordion is expanded */
  expandedContent?: JSX.Element;
  /** Whether it is initially open, defaults to true */
  isOpen?: boolean;
}

/**
 * Expandable accordion showing information about the participant's HLC result.
 */
@observer
export class SectionAccordion extends React.Component<SectionAccordionProps> {
  /** Whether the accordion is in expanded mode */
  @observable.ref
  expanded: boolean = this.props.isOpen !== undefined ? this.props.isOpen : true;

  /** Renders the component */
  render() {
    return (
      <div className={this.props.className}>
        <div className={styles.header} onClick={this.onToggleExpansion}>
          {this.props.expandedContent ? (
            <div className={styles.expander}>
              {this.expanded ? (
                <AccordionOpenIcon size="small" color="black" />
              ) : (
                <AccordionClosedIcon size="small" color="black" />
              )}
            </div>
          ) : (
            undefined
          )}
          <div className={styles.heading}>
            <div data-tour={this.props.headerTitle} className={styles.title}>
              {this.props.headerTitle}
            </div>
          </div>
        </div>
        {this.expanded ? <div className={styles.expandedContent}>{this.props.expandedContent}</div> : undefined}
      </div>
    );
  }

  /** Expands or collapses the accordion */
  @action
  onToggleExpansion = () => {
    this.expanded = !this.expanded;
  };
}



// WEBPACK FOOTER //
// ./src/ui/components/section-accordion/section-accordion.tsx